import type { LoggingCondition } from '@/api-client/alert/model';
import type { CustomColumn } from '@/common/utils';

// field 를 응답 타입 키로 제약해, 응답에 없는 필드명 바인딩이 컴파일에서 걸리게 한다
export const PATH_COLUMNS: CustomColumn<keyof LoggingCondition>[] = [
  {
    caption: 'Path Name',
    field: 'pathName',
    type: 'string',
    width: 175,
  },
  {
    caption: 'Log Type',
    field: 'logType',
    type: 'string',
    width: 175,
  },
  {
    caption: 'Path',
    field: 'filePath',
    type: 'string',
    width: 175,
  },
  {
    caption: 'Filter',
    field: 'filterDetailValues',
    rendererType: 'chip-cell',
    type: 'string',
  },
  {
    caption: 'Parser',
    field: 'logParserItems',
    type: 'string',
    rendererType: 'chip-cell',
  },
] as const;

export const ALERT_CONTROL_TYPE_LABEL = {
  STOP: 'WORD.ALERT_STOP',
  CLEAR: 'WORD.ALERT_CLEAR',
} as const;
